import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Box, Button } from '@material-ui/core';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import Visualization from 'Components/UI/Snapshot/Holdings/Visualization';
import { householdHoldings } from 'Consts/advisorUris';
import relationships from 'Consts/Relationships';
import { ChevronRight } from '@material-ui/icons';
import {
  PortfolioProvider,
  usePortfolioStateContext,
} from 'Components/UI/Portfolio/PortfolioContext';

const HoldingsChart = ({ classes }) => {
  const state = usePortfolioStateContext();
  const portfolio = state.portfolioCollection?.resources().head();
  return <Visualization className={classes.chart} portfolio={portfolio} />;
};

HoldingsChart.propTypes = {
  classes: PropTypes.object.isRequired,
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  skeleton: {
    alignSelf: 'center',
    margin: 'auto',
  },
  chartContainer: {
    display: 'flex',
    flexGrow: 1,
    position: 'relative',
  },
  chart: {
    height: '100%',
    width: '100%',
    maxWidth: 'calc(100% - 48px)',
    margin: 'auto',
  },
}));

export default function ChartsContainer() {
  const classes = useStyles();
  const { householdResource } = useSimpleHousehold();

  const portfolioRel = householdResource
    ?.relationship(relationships.portfolio)
    ?.link('related');

  return (
    <div className={classes.root}>
      <Box className={classes.buttonContainer}>
        <Button
          color="primary"
          href={householdHoldings(householdResource.resourceId, {
            tab: 'holdings',
          })}
          endIcon={<ChevronRight />}
        >
          Go to Holdings
        </Button>
      </Box>
      <div className={classes.chart}>
        <PortfolioProvider portfolioRelationship={portfolioRel}>
          <HoldingsChart classes={classes} />
        </PortfolioProvider>
      </div>
    </div>
  );
}
